<template lang="">
    <div class="operation">
 <a-row :gutter="16" style="height: 100%">
                <a-col :span="6" style="height: 100%">
                    <a-row :gutter="16" style="height: 33.33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer :title="$t('用水量分析')" >
                                <WaterUsageAnalysis />
                            </DataContainer>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" style="height: 33.33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer  :title="$t('用水类型分析')">
                                <WaterTypeAnalysis />
                            </DataContainer>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" style="height: 33.33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer  :title="$t('用户近半年用水统计')">
                                <UserWaterTrend />
                            </DataContainer>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="12" style="height: 100%">
                    
                </a-col>
                <a-col :span="6" style="height: 100%">
                <a-row :gutter="16" style="height: 33.33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer  :title="$t('营收统计')">
                                <RevenueStats />
                            </DataContainer>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" style="height: 33.33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer  :title="$t('年应收')">
                                <AnnualRevenue />
                            </DataContainer>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" style="height: 33.33%">
                        <a-col :span="24" style="height: 100%">
                            <DataContainer  :title="$t('近一年月用水/缴费统计')">
                                <MonthlyTrend />
                            </DataContainer>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
    </div>
</template>
<script>
import DataContainer from './DataContainer.vue'
import AnnualRevenue from './modules/operation/AnnualRevenue.vue'
import MonthlyTrend from './modules/operation/MonthlyTrend.vue'
import WaterTypeAnalysis from './modules/operation/WaterTypeAnalysis.vue'
import UserWaterTrend from './modules/operation/UserWaterTrend.vue'
import RevenueStats from './modules/operation/RevenueStats.vue'
import WaterUsageAnalysis from './modules/operation/WaterUsageAnalysis.vue'

export default {
    name: 'operation',
    components: {
        DataContainer,
        AnnualRevenue,
        MonthlyTrend,
        WaterTypeAnalysis,
        UserWaterTrend,
        RevenueStats,
        WaterUsageAnalysis
    },
    props: {
        // 可以添加一些props
    },
    data() {
        return {
        // 可以添加一些数据属性
        }
    },
    methods: {
        // 可以添加一些方法
    },
    mounted() {
        // 可以在这里执行一些初始化操作
    }
    
}
</script>
<style lang="less" scoped>
.operation {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>